import React from 'react';

export const WindowSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_6933_3515)">
          <path fill-rule="evenodd" clipRule="evenodd" d="M1 36H35C35.55 36 36 35.55 36 35V1C36 0.45 35.55 0 35 0H1C0.45 0 0 0.45 0 1V35C0 35.55 0.45 36 1 36ZM32 4H4V32H32V4Z" fill={color} />
          <path d="M16 2H20V34H16V2Z" fill={color} />
          <path d="M2 21V18H34V21H2Z" fill={color} />
        </g>
        <defs>
          <clipPath id="clip0_6933_3515">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18688)">
        <path d="M35 36H1C0.45 36 0 35.55 0 35V1C0 0.45 0.45 0 1 0H35C35.55 0 36 0.45 36 1V35C36 35.55 35.55 36 35 36Z" fill="#981313" />
        <path d="M0.999945 36.0009H34.9999C35.5499 36.0009 35.9999 35.5509 35.9999 35.0009V1.00092C35.9999 0.725922 35.8879 0.475922 35.7059 0.294922L0.293945 35.7069C0.474945 35.8889 0.724945 36.0009 0.999945 36.0009Z" fill="#983813" />
        <path d="M2 2H34V34H2V2Z" fill="#AEDDF7" />
        <path opacity="0.5" d="M2 34V2H34L2 34Z" fill="white" />
        <path d="M17 2H19V34H17V2Z" fill="#983813" />
        <path d="M2 19V17H34V19H2Z" fill="#983813" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18688">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}